<template>
  <b-modal
    @hide="refreshPage"
    id="changeRoleByDiffAdminModal"
    class="popover-modal"
    hide-header
    hide-footer
    no-close-on-esc
    ref="changeRoleByDiffAdminModal"
  >
    <div class="content-cont">
      <p class="header-title text-center">Permissions Updated</p>
      <div class="hint-modal" v-html="message"></div>
      <!-- action btns  -->
      <hr class="h-line" />
      <div class="action-btns">
        <button
          @click="refreshPage"
          class="dismiss-action-btn btn btn-primary"
          size="md"
        >
          Okay
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "userRoleChangedModal",
  props: ["permissionsData"],
  data() {
    return {
      message: null,
    };
  },
  methods: {
    refreshPage() {
      if (this.$route.name == "dashboard") {
        window.location.reload();
      } else {
        window.location.href = "/";
      }
    },
  },
  watch: {
    permissionsData(data) {
      // console.log('dataaaaa', data);
      let siteText = "";
      let userTypeText = "";
      if (data.sites && data.sites.length == 1) {
        siteText = "site";
      } else {
        siteText = "sites";
      }

      if (data.userTypes && data.userTypes.length == 1) {
        userTypeText = "user type";
      } else {
        userTypeText = "user types";
      }

      let sites = [...new Set(data.sites)];
      let userTypes = [...new Set(data.userTypes)];
      sites = "“" + sites.join("” , “") + "”";
      userTypes = "“" + userTypes.join("” , “") + "”";

      // console.log('this.sitesNames', sites);
      // console.log('this.userTypesNames', userTypes);

      if (data.oldRole && data.newRole) {
        this.message = `<p class='hint-text'>Your user role has been changed from <span class=' bold-text'>“${data.oldRole.name}”</span> to <span class=' bold-text'>“${data.newRole.name}”</span> and you will be able to access all the data related 
                to <span class='bold-text break-word'>${sites}</span> ${siteText} and <span class='bold-text break-word'>${userTypes}</span> ${userTypeText}. The pages you are allowed to access will change.</p>`;
      } else {
        this.message = `<p>Your permissions have been updated and you will be able to access all the data related to <span class=' bold-text  break-word'>${sites}</span> ${siteText} and <span class=' bold-text break-word'>${userTypes}</span> ${userTypeText}.</p>`;
      }
    },
  },
};
</script>

<style lang="scss">
div#changeRoleByDiffAdminModal {
  padding-inline-end: 0px !important;
  border-radius: 26px;

  div#changeRoleByDiffAdminModal___BV_modal_content_ {
    border-radius: 26px;
    width: 502.7px !important;
    top: 50px;
  }
  .modal-content .modal-body {
    padding: 0px !important;
    p.header-title {
      font-style: normal;
      font-weight: 700;
      font-size: 17px;
      line-height: 20px;
      margin: 40px 0;
      color: #000000;
    }
    .hint-modal {
      width: 420px;

      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 23.6px;
      margin: 0 auto 40px auto;
      text-align: center;
      color: #4a4a4a;
    }
    .h-line {
      opacity: 0.15;
      background: #707070;
      width: 420px;
      margin: 0px auto 24px auto;
    }
    .action-btns {
      margin-bottom: 20px;
      .dismiss-action-btn {
        background: #103f5e;
        border-radius: 16.6275px;
        width: 111px;
        height: 33px;
        color: #ffffff;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        text-align: center;
      }
    }
    .bold-text {
      display: inline;
      font-weight: 700;
    }
    .break-word{
      overflow-wrap:break-word;
    }
  }
}
</style>
